import { useState, useEffect } from 'react';
import { hospitalService } from '../services/api';

export const useHospitals = (params = {}) => {
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHospitals = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await hospitalService.getAll(params);
      setHospitals(response.data.hospitals || []);
    } catch (err) {
      console.error('Error fetching hospitals:', err);
      if (err.message === 'Request timeout') {
        setError('Request timed out. Please check your internet connection and try again.');
      } else {
        setError(err.message);
      }
      setHospitals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHospitals();
  }, [JSON.stringify(params)]);

  return { hospitals, loading, error, refetch: fetchHospitals };
};

export const useTurkeyHospitals = (params = {}) => {
  const { hospitals, loading, error, refetch } = useHospitals({ ...params, limit: 100 });
  
  // Filter to ensure only Turkey hospitals show up
  const filteredHospitals = hospitals.filter(hospital => 
    hospital.country && hospital.country.toLowerCase() === 'turkey'
  );
  
  return { hospitals: filteredHospitals, loading, error, refetch };
};

export const useThailandHospitals = (params = {}) => {
  const { hospitals, loading, error, refetch } = useHospitals({ ...params, limit: 100 });
  
  // Filter to ensure only Thailand hospitals show up
  const filteredHospitals = hospitals.filter(hospital => 
    hospital.country && hospital.country.toLowerCase() === 'thailand'
  );
  
  return { hospitals: filteredHospitals, loading, error, refetch };
};

export const useIndiaHospitals = (params = {}) => {
  const { hospitals, loading, error, refetch } = useHospitals({ ...params, limit: 100 });
  
  // Filter to ensure only India hospitals show up
  const filteredHospitals = hospitals.filter(hospital => 
    hospital.country && hospital.country.toLowerCase() === 'india'
  );
  
  return { hospitals: filteredHospitals, loading, error, refetch };
};

export const useSouthKoreaHospitals = (params = {}) => {
  const { hospitals, loading, error, refetch } = useHospitals({ ...params, limit: 100 });
  
  // Filter to ensure only South Korea hospitals show up
  const filteredHospitals = hospitals.filter(hospital => 
    hospital.country && hospital.country.toLowerCase() === 'south korea'
  );
  
  return { hospitals: filteredHospitals, loading, error, refetch };
};

export const useAllHospitals = (params = {}) => {
  return useHospitals({ ...params, limit: 1000 });
};
